import React, { useState } from "react";
import styles from "./style.module.css";

interface Props {
  open?: boolean;
  buttonText: string;
  buttonSubCont?: React.ReactNode;
  toggleContent: React.ReactNode;
  hiddenBorder?: boolean;
  bottomContent?: React.ReactNode;
}

export default function ToggleBox({
  buttonText,
  buttonSubCont,
  toggleContent,
  hiddenBorder,
  open: initOpen,
  bottomContent,
}: Props) {
  const [open, setOpen] = useState<boolean>(initOpen || true);
  const handleOpen = () => setOpen(!open);

  return (
    <div
      className={`${styles.toggleBox} ${hiddenBorder && styles.hiddenBorder}`}
    >
      <div className={styles.toggleButton} onClick={handleOpen}>
        <div className={styles.toggleButtonContent}>
          <h5>{buttonText}</h5>
          <div>{buttonSubCont}</div>
        </div>
        <img
          className={`${styles.toggleArrow} ${
            open && styles.activeToggleArrow
          }`}
          alt="arrow"
          src="/images/arrow.png"
        />
      </div>

      {open && <div className={styles.toggleContent}>{toggleContent}</div>}

      {bottomContent && (
        <div className={styles.toggleBottomContent}>{bottomContent}</div>
      )}
    </div>
  );
}
